import {
   VERIFY_REQUEST,
   VERIFY_SUCCESS,
   // CORE_LOAD_ROOMINFO_FAILURE
} from '../types'
const initialStateObj = {}
// requestState = 'request'
// , initialState = []
// , initialStateObj = {}
export default {
   auth: (state = initialStateObj, action) => {
      switch (action.type) {
         case VERIFY_REQUEST:
            return state
         case VERIFY_SUCCESS:
            let result = {}
            if (action && action.payload && typeof action.payload === 'object') {
               result = action.payload
            }
            return result
         default:
            return state
      }
   },
}



// WEBPACK FOOTER //
// ./src/reducers/reducerAuth.js